export enum RidesViewTypeEnum {
  GridMultiSelect = "GridMultiSelect",
  GridSingleSelect = "GridSingleSelect",
  Kanban = "Kanban",
  Map = "Map",
  CardBoard = "CardBoard",
  LiveMap = "LiveMap",
  Calendar = "Calendar",
}
